import React from 'react';
import PropTypes from 'prop-types';
import { NavLink } from 'react-router-dom';
import trans from 'translate';

import './CustomLink.scss';

const CustomLink = ({ style, to, text, className, onClick, children, ...rest }) => {
  const handleClick = (e) => {
    const { disabled } = rest || {};
    if (disabled) e.preventDefault();
    onClick();
  };
  return (
    <NavLink
      to={to}
      className={`link${className ? ` ${className}` : ''}`}
      style={style}
      {...rest}
      onClick={handleClick}
    >
      {children || trans(text)}
    </NavLink>
  );
};

CustomLink.defaultProps = {
  style: null,
  className: null,
  children: null,
  text: null,
  onClick: () => {},
};

CustomLink.propTypes = {
  style: PropTypes.object,
  className: PropTypes.string,
  text: PropTypes.string,
  to: PropTypes.string.isRequired,
  children: PropTypes.node,
  onClick: PropTypes.func,
};

export default CustomLink;
